import React from "react";
import { Route, Link, matchPath } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";
import routes from "../../Routes/routes";
import { FormattedMessage } from "react-intl";

const findRouteName = (match) => {
  let found;
  let ret;
  var urls = match.url.split("/");
  const urlOffsetForLocation = 3;
  if (
    urls[urls.length - urlOffsetForLocation] === "studentview" ||
    urls[urls.length - urlOffsetForLocation] === "programmeview" ||
    urls[urls.length - urlOffsetForLocation] === "classview" ||
    urls[urls.length - urlOffsetForLocation] === "teacherview"
  ) {
    ret = { pathName: urls[urls.length - 1], useFormatted: false };
    return ret;
  }
  for (let path of Object.entries(routes)) {
    found = matchPath(match.url, { path, exact: true });
    if (found) {
      ret = { pathName: routes[found.path], useFormatted: true };
      return ret;
    }
  }
  return null;
};

const getPaths = (pathname) => {
  const paths = ["/"];
  if (pathname === "/") return paths;

  pathname.split("/").reduce((prev, curr, index) => {
    const currPath = `${prev}/${curr}`;
    paths.push(currPath);
    return currPath;
  });
  return paths;
};

const BreadcrumbsItem = ({ path, match, ...rest }) => {
  const routeName = findRouteName(match);
  if (routeName) {
    if (routeName.pathName && routeName.useFormatted) {
      return match.isExact ? (
        <BreadcrumbItem active>
          <FormattedMessage id={routeName.pathName} />
        </BreadcrumbItem>
      ) : (
        <BreadcrumbItem>
          <Link to={match.url || ""}>
            <FormattedMessage id={routeName.pathName} />
          </Link>
        </BreadcrumbItem>
      );
    } else if (routeName.pathName && !routeName.useFormatted) {
      return match.isExact ? (
        <BreadcrumbItem active>{routeName.pathName}</BreadcrumbItem>
      ) : (
        <BreadcrumbItem>
          <Link to={match.url || ""}>{routeName.pathName}</Link>
        </BreadcrumbItem>
      );
    }
  }
  return null;
};

const Breadcrumbs = ({ location: { pathname }, match }) => {
  const paths = getPaths(pathname);
  const items = paths.map((path, i) => (
    <Route key={i++} path={path} component={BreadcrumbsItem} />
  ));

  return <Breadcrumb>{items}</Breadcrumb>;
};

export default function BreadCrumbs(props) {
  return (
    <div>
      <Route path="/:path" component={Breadcrumbs} {...props} />
    </div>
  );
}
